<div id="divToPrintByJsPdf">
    <div class="headers">
        <div>{{pageTitle}}</div>
        <div>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.dossier' | translate}} {{entryToPrint?.noDossier}}
        </div>
    </div>
    <div [style.backgroundImage]="'url(' + mapScreenshotUrl + ')'"
        class="mapScreenshotContainer"></div>
    <div class="footer">
        <div class="otherMap">
            <div>Localisation</div>
            <igo-map-browser *ngIf="otherMap"
                [map]="otherMap"></igo-map-browser>
        </div>
        <div class="legend">
            <div class="title">{{ 'sigt.integration.rechercheGdf.form.serviceGdf.beauxFoncier' | translate}}</div>
            <div><span
                    style="background-color: rgba(89, 200, 20, 0.8); border: solid 1px black; width: 10px; height: 10px; border-radius: 50%; display: inline-block; "></span>
                {{ 'sigt.integration.rechercheGdf.form.serviceGdf.bail' | translate}} {{entryToPrint?.noDossier}}</div>
            <div><img [src]="temporaryDroitWmsLayerLegend"></div>
        </div>
        <div class="details">
            <div>
                <div class="title">{{ 'sigt.integration.rechercheGdf.form.serviceGdf.metadonnees' | translate}}
                </div>
                <div>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.projection' | translate}}</div>
                <div class="scale-bar"
                    [style.backgroundImage]="'url(' + mapScaleScreenshotUrl + ')'"></div>
            </div>
            <div>
                <div class="title">{{ 'sigt.integration.rechercheGdf.form.serviceGdf.sources' | translate}}</div>
                <table>
                    <tr>
                        <th>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.donnees' | translate}}</th>
                        <th>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.organisme' | translate}}</th>
                        <th>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.annee' | translate}}</th>
                    </tr>
                    <tr>
                        <td>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.asisseCarto' | translate}}</td>
                        <td>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.mrnf' | translate}}</td>
                        <td>{{ currentYear }}</td>
                    </tr>
                    <tr>
                        <td>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.photoAerienne' | translate}}</td>
                        <td>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.mrnf' | translate}}</td>
                        <td>{{ mapYear$ | async}}</td>
                    </tr>
                </table>

            </div>
            <div>
                <div class="title">{{ 'sigt.integration.rechercheGdf.form.serviceGdf.realisation' | translate}}</div>
                <div [innerHTML]="'sigt.integration.rechercheGdf.form.serviceGdf.textRealisation' | translate"></div>
                <div>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.copyRight' | translate}},
                    {{today.toLocaleDateString('fr-FR', {day: 'numeric', month: 'long', year: 'numeric'})}}</div>
            </div>
        </div>
        <div>
            <img src="assets/images/logoMrnfBlack.png">
        </div>
    </div>
</div>

<div id="divGeneratePDFWithJsPdf">
    <button mat-raised-button
        color="primary"
        (click)="generatePDFWithJsPdf()">{{ 'sigt.global.boutons.print' | translate}}</button>
</div>